/**
 * View that handles displaying and navigating the steps of the KB creation wizard
 */
define([
  "marionette",
  "modules/accountAdmin/kbWizardModal/kbWizardStep/template/kbWizardStepTemplate.html",
], function (Marionette, KbWizardStepTemplate) {
  var KbWizardStepView = {};

  KbWizardStepView.kbWizardStepView = Marionette.ItemView.extend({
    template: KbWizardStepTemplate,
    modelEvents: {
      change: "render",
    },
  });

  return KbWizardStepView;
});
